import { FormatOptions } from '../types/wordpress';

let formatOptions: FormatOptions = {
    date_format: 'MMM d, yyyy',
    time_format: 'HH:mm',
    number_format: {
        decimal_separator: '.',
        thousand_separator: ',',
        decimals: 2
    },
    currency_format: {
        symbol: '$',
        position: 'left',
        thousand_separator: ',',
        decimal_separator: '.',
        decimals: 2
    },
    measurement_format: {
        weight_unit: 'kg',
        dimension_unit: 'cm',
        thousand_separator: ',',
        decimal_separator: '.',
        decimals: 2
    }
};

export const setFormatOptions = (options: FormatOptions) => {
    formatOptions = { ...formatOptions, ...options };
};

export const formatDate = (date: string): string => {
    try {
        return new Date(date).toLocaleString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    } catch (error) {
        console.error('Date formatting error:', error);
        return date;
    }
};

export const formatNumber = (value: number): string => {
    try {
        const { decimal_separator, thousand_separator, decimals } = formatOptions.number_format;
        return new Intl.NumberFormat(undefined, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        }).format(value)
            .replace(/,/g, '{{thousand}}')
            .replace(/\./g, '{{decimal}}')
            .replace(/{{thousand}}/g, thousand_separator)
            .replace(/{{decimal}}/g, decimal_separator);
    } catch (error) {
        console.error('Number formatting error:', error);
        return value.toString();
    }
};

export const formatCurrency = (value: number): string => {
    try {
        const { symbol, position, decimal_separator, thousand_separator, decimals } = formatOptions.currency_format;
        const number = formatNumber(value);

        switch (position) {
            case 'left': return `${symbol}${number}`;
            case 'right': return `${number}${symbol}`;
            case 'left_space': return `${symbol} ${number}`;
            case 'right_space': return `${number} ${symbol}`;
            default: return `${symbol}${number}`;
        }
    } catch (error) {
        console.error('Currency formatting error:', error);
        return value.toString();
    }
};

export const formatMeasurement = (value: number, type: 'weight' | 'dimension'): string => {
    try {
        const { weight_unit, dimension_unit, decimals } = formatOptions.measurement_format;
        const formattedNumber = formatNumber(value);
        const unit = type === 'weight' ? weight_unit : dimension_unit;
        return `${formattedNumber} ${unit}`;
    } catch (error) {
        console.error('Measurement formatting error:', error);
        return value.toString();
    }
}; 